import { render, staticRenderFns } from "./PaymentOrderMealCard.vue?vue&type=template&id=7248d77e&scoped=true"
import script from "./PaymentOrderMealCard.vue?vue&type=script&lang=js"
export * from "./PaymentOrderMealCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentOrderMealCard.vue?vue&type=style&index=0&id=7248d77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7248d77e",
  null
  
)

export default component.exports